import { render } from "./PageHeaderHome.vue?vue&type=template&id=7a476600"
import script from "./PageHeaderHome.js?vue&type=script&lang=js"
export * from "./PageHeaderHome.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__